<template>
  <el-tooltip
    ref="tooltip"
    v-model="val"
    :effect="effect"
    :content="elContent || content"
    :placement="placement"
    :disabled="disabled"
    :offset="offset"
    :enterable="enterable"
    :transition="transition"
    :visible-arrow="visibleArrow"
    :open-delay="openDelay"
    :hide-after="hideAfter"
    :popper-class="popperClass"
    :manual="manual"
    :popper-options="popperOptions"
    :tabindex="tabindex"
  >
    <template v-if="$scopedSlots.content">
      <slot slot="content" name="content"></slot>
    </template>
    <slot></slot>
  </el-tooltip>
</template>
<script>
import { debounce } from 'lodash-es'
export default {
  name: 'SuiTooltip',
  props: {
    value: {
      type: Boolean
    },
    // 默认提供的主题 dark/light
    effect: {
      type: String,
      default: 'dark',
      validator: (value) => ['dark', 'light'].indexOf(value) !== -1
    },
    // 提示信息内容
    content: {
      type: String,
      default: ''
    },
    // 提示信息的方位
    placement: {
      type: String,
      default: 'top',
      validator: (value) => {
        return (
          [
            'top',
            'left',
            'right',
            'bottom',
            'top-start',
            'left-start',
            'right-start',
            'bottom-start',
            'top-end',
            'left-end',
            'right-end',
            'bottom-end'
          ].indexOf(value) !== -1
        )
      }
    },
    // 是否禁用
    disabled: {
      type: Boolean
    },
    // 偏移量
    offset: {
      type: Number,
      default: 0
    },
    // 鼠标是否可进入到 tooltip 中
    enterable: {
      type: Boolean,
      default: true
    },
    // 渐变动画
    transition: {
      type: String,
      default: 'el-fade-in-linear'
    },
    // 是否显示箭头
    visibleArrow: {
      type: Boolean,
      default: true
    },
    // 延迟出现，单位毫秒
    openDelay: {
      type: Number,
      default: 0
    },
    // 多少秒之后自动隐藏，单位毫秒，0代表不自动隐藏
    hideAfter: {
      type: Number,
      default: 0
    },
    // 提示框的样式名
    popperClass: {
      type: String,
      default: ''
    },
    // 手动控制模式，设置为 true 后，mouseenter 和 mouseleave 事件将不会生效
    manual: {
      type: Boolean
    },
    popperOptions: {
      type: Object,
      default: () => ({
        gpuAcceleration: false
      })
    },
    tabindex: {
      type: Number,
      default: 0
    },
    maxWidth: {
      type: String,
      default: '100%'
    }
  },
  data() {
    return {
      elContent: ''
    }
  },
  computed: {
    // 组件的值。
    val: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      let tooltip = this.$refs.tooltip
      if (tooltip) {
        tooltip.$refs.popper && (tooltip.$refs.popper.style.maxWidth = this.maxWidth)
      }
    })
  },
  methods: {
    showTip(el) {
      let tooltip = this.$refs.tooltip
      if (tooltip) {
        this.elContent = el.innerText || el.textContent
        tooltip.referenceElm = el
        tooltip.$refs.popper && (tooltip.$refs.popper.style.display = 'none')
        tooltip.doDestroy()
        tooltip.setExpectedState(true)
        debounce((tooltip) => tooltip.handleShowPopper(), 50)(tooltip)
      }
    },
    hideTip() {
      let tooltip = this.$refs.tooltip
      if (tooltip) {
        tooltip.setExpectedState(false)
        tooltip.handleClosePopper()
      }
    },
    updatePopper() {
      this.$refs.tooltip.updatePopper()
    }
  }
}
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/SimbartUI/components/func/SuiTooltip.vue